import apiClient from "./apiClient";

const BASE = "/api/Cash";

// Cash Master looks like Bank Master (same /all + /save upsert shape) but is NOT a
// multi-account master — see HANDOVER_FRONTEND 4.md §9. No transaction table carries a
// cashID: Invoice Payments/Expense/Income/Supplier Advance/Supplier Payment just record
// paymentMode/paymentType = "Cash". The only thing a Cash row does is supply the opening
// balance that seeds the Cash Report's running balance, and the report sums openingBalance
// across every Active row. So the UI deliberately manages exactly ONE row
// (see feature-module/cash/CashSettings.jsx) and no form anywhere gets a "cash account"
// picker — a second row would just silently inflate the report's starting balance.

// API returns cashID (no `id`) — alias it, matching bankService.js's withId convention.
const withId = (c) => ({ ...c, id: c.cashID });

export const getCashAccounts = async () => {
  const res = await apiClient.get(`${BASE}/all`);
  return { ...res, data: (res.data || []).map(withId) };
};
export const createCashAccount = (data) =>
  apiClient.post(`${BASE}/save`, { cashName: data.cashName, openingBalance: Number(data.openingBalance) || 0 });
export const updateCashAccount = (id, data) =>
  apiClient.post(`${BASE}/save`, { cashName: data.cashName, openingBalance: Number(data.openingBalance) || 0, cashID: id });
export const deleteCashAccount = () => Promise.reject(new Error("Delete not supported by API"));
